import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { IconList, IconProgram } from '@Knowledge-OTP/znk-ui-components'
import './index.css'

const ViewToggle = ({ className = '' }) => {
  const history = useHistory()
  const location = useLocation()
  const isCalendarActive = location.pathname.startsWith('/calendar')

  return (
    <div className={`view-toggle ${className}`} role='tablist' aria-label='Lessons view'>
      <button
        type='button'
        role='tab'
        aria-selected={!isCalendarActive}
        className={`view-toggle__option ${!isCalendarActive ? 'view-toggle__option--active' : ''}`}
        onClick={() => history.push('/lessons')}
      >
        <IconList size={16} />
        <span>List</span>
      </button>
      <button
        type='button'
        role='tab'
        aria-selected={isCalendarActive}
        className={`view-toggle__option ${isCalendarActive ? 'view-toggle__option--active' : ''}`}
        onClick={() => history.push('/calendar')}
      >
        <IconProgram size={18} />
        <span>Calendar</span>
      </button>
    </div>
  )
}

export default ViewToggle
